import { api } from '@/core/api/';
import axiosResponseTypes from '@/utils/constants/axiosResponseTypes.js';

export default {
  getReport(route, params, responseType = axiosResponseTypes.default) {
    return api.get(`/api/report/${route}`, {
      responseType,
      params: {
        ...params,
      },
    });
  },
  getReportFile(route, params) {
    return api.get(`/api/report/${route}`, {
      params: {
        ...params,
      },
      responseType: 'blob',
      transformResponse: [],
    });
  },

  queueReport(route, params) {
    return api.post(`/api/report/queue${route}`, params);
  },

  cancelQueueReport(executionLogId) {
    return api.post(`api/report/cancelqueuedreport/${executionLogId}`);
  },

  downloadQueueReport(executionLogId) {
    return api.get(`/api/report/downloadqueuereport/${executionLogId}`);
  },

  //This is for reports generated by queue.
  getPreviousGeneratedReport(types) {
    const toQuery = types.map((value) => `types=${value}`).join('&');
    return api.get(`/api/report/getpreviousgeneratedreportbytype?${toQuery}`);
  },
  getTeachersAlternativesReport(payload) {
    return api.post(`/api/report/teachersAlternatives`, payload);
  },
  getStudentsAlternativesReport(payload) {
    return api.post(`/api/report/studentsalternatives`, payload);
  },
  getTherapyRoomsHipaaReport(params) { 
    return api.get(`/api/report/therapyroomshipaa`, {params});
  },
};
